export default __webpack_public_path__ + "static/social-media-templates-0fb88f584c25b7f72ceb6de86f9a95b0.jpg";